import { Expose } from "class-transformer";
import { EmployeeDocumentOriginEnum } from "@/core/features/employee-documents/employee-document-origin.enum";

export class CreateEmployeeDocumentVersionDto {
  @Expose()
  employeeId: string;

  @Expose()
  categoryId: string;

  @Expose()
  origin: EmployeeDocumentOriginEnum;

  @Expose()
  filename?: string;
}
